import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobhimashankarcab() {



const cardData = {
  keyword: " Pune to Bhimashankar Cab  ",

"headingDescription": "Pune to Bhimashankar Cab service offers a safe, comfortable, and reliable travel option for devotees and travelers visiting the sacred Bhimashankar Jyotirlinga. Ideal for religious trips, weekend getaways, and family journeys, our professional drivers and well-maintained vehicles ensure a smooth ride through scenic forest and ghat routes. We provide one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. With SRS Pune to Bhimashankar Cab, enjoy easy online booking, 24/7 customer support, and a peaceful journey to one of Maharashtra’s most important pilgrimage destinations.",
"topPlaces": [
  {
    "title": "Bhimashankar Temple",
    "description": "Bhimashankar Temple is one of the twelve Jyotirlingas of Lord Shiva and the main attraction for devotees. Travelers booking Pune to Bhimashankar Cab visit this sacred temple to seek blessings and experience its spiritual atmosphere."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary",
    "description": "Bhimashankar Wildlife Sanctuary is known for its dense forests and rich biodiversity. Visitors using Pune to Bhimashankar Cab can explore nature trails, spot wildlife, and enjoy the peaceful environment."
  },
  {
    "title": "Hanuman Lake",
    "description": "Hanuman Lake is a serene water body located near the temple, offering a calm and scenic environment. Travelers often relax here during their Pune to Bhimashankar Cab trip and enjoy the natural beauty."
  },
  {
    "title": "Gupt Bhimashankar",
    "description": "Gupt Bhimashankar is believed to be the origin point of the Bhima River. Devotees visiting through Pune to Bhimashankar Cab explore this hidden spiritual spot surrounded by lush greenery."
  },
  {
    "title": "Nagphani Point",
    "description": "Nagphani Point, also known as Duke’s Nose of Bhimashankar, offers breathtaking panoramic views of the Sahyadri hills. Adventure lovers traveling via Pune to Bhimashankar Cab often trek here for stunning landscapes."
  },
  {
    "title": "Ahupe Waterfall",
    "description": "Ahupe Waterfall is a seasonal waterfall surrounded by dense forest and hills. Visitors using Pune to Bhimashankar Cab can enjoy this scenic spot, especially during the monsoon season."
  },
  {
    "title": "Sakshi Vinayak Temple",
    "description": "Sakshi Vinayak Temple is a small but important temple visited before reaching the main Bhimashankar Temple. Travelers often stop here during their Pune to Bhimashankar Cab journey for blessings."
  },
  {
    "title": "Bombay Point (Sunset Point)",
    "description": "Bombay Point offers beautiful sunset views over the hills and valleys. Travelers booking Pune to Bhimashankar Cab can relax here and enjoy the peaceful evening scenery."
  },
  {
    "title": "Karvi Flower Valley",
    "description": "Karvi Flower Valley is famous for its rare blooming flowers that appear once every few years. Nature lovers using Pune to Bhimashankar Cab can witness this unique natural phenomenon when in season."
  },
  {
    "title": "Bhimashankar Trek Route",
    "description": "The Bhimashankar Trek Route is popular among adventure enthusiasts for its forest trails and scenic views. Travelers using Pune to Bhimashankar Cab often combine their trip with trekking for a complete nature experience."
  }
],



services: [
{
name: "Pune to Bhimashankar Cab",
description: "Pune to Bhimashankar cab service offers reliable travel for Jyotirlinga darshan trips. Customers can book cabs for one-way or round journeys. Professional drivers ensure safe travel through ghat roads. Comfortable vehicles enhance long-distance travel experience. Transparent pricing ensures affordability. Travel conveniently from Pune to Bhimashankar with cab services."
},
{
name: "Pune to Bhimashankar Taxi Fare",
description: "Pune to Bhimashankar taxi fare service provides clear pricing details for travelers. Customers can check fare estimates before booking rides. Affordable rates ensure budget-friendly pilgrimage travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Choose taxi services with transparent fare for Bhimashankar travel."
},
{
name: "Pune to Bhimashankar Cab Fare",
description: "Pune to Bhimashankar cab fare offers detailed pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel confidently with cab fare services from Pune to Bhimashankar."
},
{
name: "Taxi from Pune to Bhimashankar",
description: "Taxi from Pune to Bhimashankar provides convenient travel for temple visits. Customers can book taxis for direct darshan trips. Professional drivers ensure safe and timely journeys. Comfortable vehicles enhance travel comfort. Flexible booking options are available. Choose taxi services for Pune to Bhimashankar travel."
},
{
name: "Pune to Bhimashankar Cab Price",
description: "Pune to Bhimashankar cab price service provides clear pricing information for travelers. Customers can compare rates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent pricing for Bhimashankar trips."
},
{
name: "Book Cab from Pune to Bhimashankar",
description: "Book cab from Pune to Bhimashankar service offers easy online reservation options. Customers can book rides instantly for temple visits. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Book your cab easily from Pune to Bhimashankar."
},
{
name: "Pune to Bhimashankar by Cab Charges",
description: "Pune to Bhimashankar by cab charges provide estimated costs for travel planning. Customers can check pricing details before booking rides. Affordable rates ensure budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel confidently with transparent cab charges."
},
{
name: "Pune to Bhimashankar Cab Booking",
description: "Pune to Bhimashankar cab booking offers quick and easy reservation options. Customers can book cabs online or via mobile apps. Professional drivers ensure safe and timely journeys. Comfortable vehicles enhance travel comfort. Flexible booking options are available. Book your cab easily for Bhimashankar trips."
},
{
name: "Pune to Bhimashankar Cab Charges",
description: "Pune to Bhimashankar cab charges service provides clear pricing details for travelers. Customers can check charges before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent charges for Bhimashankar travel."
},
{
name: "Pune to Bhimashankar Cab Package",
description: "Pune to Bhimashankar cab package offers complete travel solutions for temple visits. Customers can choose one-day or customized travel plans. Comfortable vehicles ensure smooth journeys. Professional drivers ensure safe travel. Transparent pricing ensures value for money. Book cab packages from Pune to Bhimashankar easily."
},
{
name: "Pune to Bhimashankar Car Rental",
description: "Pune to Bhimashankar car rental provides flexible vehicle options for long-distance travel. Customers can choose from sedan, SUV, and premium cars. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel comfort. Transparent pricing ensures affordability. Rent cars from Pune to Bhimashankar for convenient travel."
},
{
name: "Pune to Bhimashankar Taxi Service",
description: "Pune to Bhimashankar taxi service offers reliable transportation for pilgrimage travel. Customers can book taxis for one-way or round trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Choose taxi services for Bhimashankar travel."
},
{
name: "Pune to Bhimashankar Taxi Price",
description: "Pune to Bhimashankar taxi price service provides detailed pricing for travelers. Customers can compare rates before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose taxi services with transparent pricing."
},
{
name: "Pune to Bhimashankar Temple Cab Fare",
description: "Pune to Bhimashankar temple cab fare offers pricing for direct temple visits. Customers can check fare details before booking rides. Affordable rates ensure budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with temple cab fare services."
},
{
name: "Pune to Bhimashankar Tempo Traveller",
description: "Pune to Bhimashankar tempo traveller service offers group travel solutions for families and tours. Customers can book spacious vehicles for comfortable journeys. Professional drivers ensure safe travel on ghat roads. Ideal for group pilgrimage trips. Flexible booking options are available. Travel together with tempo traveller services."
},
{
name: "Taxi Service from Pune to Bhimashankar",
description: "Taxi service from Pune to Bhimashankar provides convenient travel for temple visits. Customers can book taxis for flexible schedules. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Transparent pricing ensures affordability. Choose taxi services for easy travel to Bhimashankar."
},
{
name: "Pune to Bhimashankar Innova Crysta",
description: "Pune to Bhimashankar Innova Crysta offers premium SUV travel for comfort and space. Customers can enjoy smooth journeys with spacious seating. Professional drivers ensure safe travel. Ideal for family trips and long-distance journeys. Transparent pricing ensures value for money. Travel comfortably with Innova Crysta services."
},
{
name: "Pune to Bhimashankar Cab Service",
description: "Pune to Bhimashankar cab service provides reliable travel for pilgrimage trips. Customers can book cabs for one-way or round trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Travel conveniently with cab services."
},
{
name: "Pune to Bhimashankar One Way Cab",
description: "Pune to Bhimashankar one way cab offers cost-effective travel without return charges. Customers can book direct one-way rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose one-way cab services for Bhimashankar travel."
},
{
name: "Pune to Bhimashankar Cab Hire",
description: "Pune to Bhimashankar cab hire offers flexible travel options for temple visits. Customers can hire vehicles for one-day or multi-day trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Transparent pricing ensures affordability. Hire cabs from Pune to Bhimashankar for easy travel."
}
],

tableData: [
["Pune to Bhimashankar Cab","Pune to Bhimashankar Taxi Fare"],
["Pune to Bhimashankar Cab Fare","Taxi from Pune to Bhimashankar"],
["Pune to Bhimashankar Cab Price","Book Cab from Pune to Bhimashankar"],
["Pune to Bhimashankar by Cab Charges","Pune to Bhimashankar Cab Booking"],
["Pune to Bhimashankar Cab Charges","Pune to Bhimashankar Cab Package"],
["Pune to Bhimashankar Car Rental","Pune to Bhimashankar Taxi Service"],
["Pune to Bhimashankar Taxi Price","Pune to Bhimashankar Temple Cab Fare"],
["Pune to Bhimashankar Tempo Traveller","Taxi Service from Pune to Bhimashankar"],
["Pune to Bhimashankar Innova Crysta","Pune to Bhimashankar Cab Service"],
["Pune to Bhimashankar One Way Cab","Pune to Bhimashankar Cab Hire"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Ghat Route Drivers",
    WhyChoosedescription: "SRS Cab Service provides expert drivers familiar with Pune to Bhimashankar ghat routes, ensuring safe driving through forest and hill sections for a smooth pilgrimage journey."
  },
  {
    WhyChooseheading: "Affordable Pune to Bhimashankar Cab Pricing",
    WhyChoosedescription: "We offer budget-friendly cab services from Pune to Bhimashankar with transparent pricing. Customers receive complete fare details including tolls and driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service for Temple Visits",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Pune to Bhimashankar cab bookings, making it convenient for early morning darshan and same-day return trips."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles for Hill Travel",
    WhyChoosedescription: "Our vehicles are clean, well-maintained, and air-conditioned, suitable for long-distance and ghat travel, ensuring a peaceful journey."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "We provide one-way cab service, round-trip bookings, and customized Bhimashankar darshan packages from Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for family and group travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We offer convenient pickup from homes, hotels, offices, and Pune Airport across all major locations including Hinjewadi, Wakad, Baner, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Pilgrimage Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Bhimashankar cab bookings due to safe driving, punctual service, and reliable vehicles for temple travel."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Bhimashankar cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Pune to Bhimashankar for comfortable pilgrimage travel." },
  { question: "How far is Bhimashankar from Pune?", answer: "The distance between Pune and Bhimashankar is approximately 110 km and the journey takes around 3 to 4 hours depending on route and traffic." },
  { question: "Is Pune to Bhimashankar cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible travel planning." },
  { question: "Which vehicles are available for Bhimashankar trip?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Pune to Bhimashankar?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Do you provide same-day return for Bhimashankar?", answer: "Yes, we offer same-day return packages for Bhimashankar darshan from Pune." },
  { question: "Are vehicles suitable for ghat and forest routes?", answer: "Yes, all vehicles are well-maintained and suitable for hill and forest travel." },
  { question: "Can I book the cab online?", answer: "Yes, you can easily book Pune to Bhimashankar cab service online or via phone." },
  { question: "Do you provide pickup from Pune home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Santosh Kulkarni",
    feedback:
      "Booked SRS Cab Service for Bhimashankar darshan. Safe driving on ghat roads and very comfortable trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meena Patil",
    feedback:
      "Excellent Pune to Bhimashankar cab service. Perfect for temple visit with family.",
    rating: 5
  }
];


































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bhimashankar Cab | SRS Cab",
  "description": "SRS Cab provides Pune to Bhimashankar cab services including one-way and round trips, cab packages, taxi services, and car rentals. Book online for safe, comfortable, and punctual rides from Pune to Bhimashankar with affordable fares and 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};








  return (
    <div>
      
<Helmet>
  <title>Pune to Bhimashankar Cab | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Bhimashankar cabs with SRS Cab. One-way, round trips, cab packages, taxi services, and car rentals with 24x7 online booking and affordable fares." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/11.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetobhimashankarcab;